"use strict";
import { Token } from "@uniswap/sdk-core";
import { createContext, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
const UserTokensContext = createContext(void 0);
export function UserTokensContextProvider({ children }) {
  const dispatch = useDispatch();
  const serializedTokens = useSelector((state) => state.user?.tokens);
  const userAddedTokens = useMemo(() => {
    const tokens = [];
    if (serializedTokens) {
      Object.values(serializedTokens).forEach((chainTokens) => {
        if (chainTokens) {
          Object.values(chainTokens).forEach((serializedToken) => {
            if (serializedToken) {
              const token = new Token(
                serializedToken.chainId,
                serializedToken.address,
                serializedToken.decimals,
                serializedToken.symbol,
                serializedToken.name
              );
              tokens.push(token);
            }
          });
        }
      });
    }
    return tokens;
  }, [serializedTokens]);
  const addUserToken = (token) => {
    dispatch({
      type: "user/addToken",
      payload: {
        token: {
          chainId: token.chainId,
          address: token.address,
          decimals: token.decimals,
          symbol: token.symbol,
          name: token.name
        }
      }
    });
  };
  const removeUserToken = (chainId, address) => {
    dispatch({
      type: "user/removeToken",
      payload: { chainId, address }
    });
  };
  return <UserTokensContext.Provider value={{ userAddedTokens, addUserToken, removeUserToken }}>
      {children}
    </UserTokensContext.Provider>;
}
export function useUserTokens() {
  const context = useContext(UserTokensContext);
  if (context === void 0) {
    throw new Error("useUserTokens must be used within a UserTokensContextProvider");
  }
  return context;
}
